import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

const AvisoLegal = () => {
  return (
    <div className="min-h-screen bg-[#020617] text-white">
      <div className="max-w-4xl mx-auto px-4 py-16">
        <Link 
          to="/" 
          className="inline-flex items-center gap-2 text-indigo-400 hover:text-indigo-300 mb-8 transition-colors"
        >
          <ArrowLeft className="w-4 h-4" />
          Volver al inicio
        </Link>
        
        <h1 className="text-4xl font-bold mb-8">Aviso Legal</h1>
        
        <div className="prose prose-invert prose-slate max-w-none space-y-8">
          <section>
            <h2 className="text-2xl font-semibold text-white mb-4">1. Datos identificativos del titular</h2>
            <p className="text-slate-300 leading-relaxed">
              En cumplimiento del deber de información recogido en el artículo 10 de la Ley 34/2002, de 11 de julio, 
              de Servicios de la Sociedad de la Información y del Comercio Electrónico (LSSI), se facilitan a continuación 
              los siguientes datos:
            </p>
            <ul className="text-slate-300 space-y-2 mt-4 list-none pl-0">
              <li><strong className="text-white">Titular del sitio web:</strong> Antonio Jesús Oliver García</li>
              <li><strong className="text-white">Nombre comercial:</strong> DATYON</li>
              <li><strong className="text-white">NIF:</strong> 15480316M</li>
              <li><strong className="text-white">Actividad:</strong> Servicios de análisis de datos, business intelligence y consultoría basada en datos</li>
              <li><strong className="text-white">Domicilio profesional:</strong> Calle de Francisco García el Maestro, 7, Derecha, 30320 Fuente Álamo, Murcia, España</li>
              <li><strong className="text-white">Correo electrónico:</strong> info@datyon.com</li>
              <li><strong className="text-white">Teléfono:</strong> 672 972 514</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-white mb-4">2. Objeto y ámbito de aplicación</h2>
            <p className="text-slate-300 leading-relaxed">
              Este sitio web tiene carácter informativo sobre los servicios profesionales ofrecidos por DATYON en el ámbito 
              del análisis de datos, business intelligence y consultoría basada en datos.
            </p>
            <p className="text-slate-300 leading-relaxed mt-4">
              El acceso y uso de este sitio web atribuye la condición de usuario e implica la aceptación plena y sin reservas 
              de todas las disposiciones incluidas en este Aviso Legal.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-white mb-4">3. Propiedad intelectual e industrial</h2>
            <p className="text-slate-300 leading-relaxed">
              Los contenidos del sitio web, incluyendo pero no limitándose a textos, fotografías, gráficos, imágenes, iconos, 
              tecnología, software, enlaces y demás contenidos audiovisuales o sonoros, así como su diseño gráfico y códigos fuente, 
              son propiedad intelectual del titular o de terceros, sin que puedan entenderse cedidos al usuario ninguno de los 
              derechos de explotación reconocidos por la normativa vigente en materia de propiedad intelectual.
            </p>
            <p className="text-slate-300 leading-relaxed mt-4">
              Las marcas, nombres comerciales y signos distintivos son propiedad del titular o de terceros, sin que pueda 
              entenderse que el acceso al sitio web atribuya ningún derecho sobre los mismos.
            </p>
            <p className="text-slate-300 leading-relaxed mt-4">
              Queda prohibida la reproducción total o parcial de los contenidos de este sitio web sin el consentimiento 
              expreso y por escrito del titular.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-white mb-4">4. Exclusión de responsabilidad</h2>
            <p className="text-slate-300 leading-relaxed">
              El titular no se hace responsable del uso indebido que los usuarios puedan hacer del contenido de este sitio web.
            </p>
            <p className="text-slate-300 leading-relaxed mt-4">
              El titular no garantiza la ausencia de errores en el acceso al sitio web, en su contenido, ni que éste se encuentre 
              actualizado, aunque se realizarán los mayores esfuerzos para, en su caso, evitarlos, subsanarlos o actualizarlos.
            </p>
            <p className="text-slate-300 leading-relaxed mt-4">
              El titular no se responsabiliza de posibles errores técnicos, interrupciones del servicio, fallos de seguridad 
              o daños que pudieran producirse en el equipo del usuario como consecuencia de virus u otros elementos dañinos.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-white mb-4">5. Enlaces externos</h2>
            <p className="text-slate-300 leading-relaxed">
              Este sitio web puede contener enlaces a sitios de terceros. El titular no asume ninguna responsabilidad 
              sobre el contenido, políticas de privacidad o prácticas de los sitios web de terceros.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-white mb-4">6. Legislación aplicable y jurisdicción</h2>
            <p className="text-slate-300 leading-relaxed">
              Las presentes condiciones se rigen por la legislación española. Para la resolución de cualquier controversia 
              que pudiera surgir en relación con el acceso o uso de este sitio web, las partes se someten a los Juzgados 
              y Tribunales de Murcia, con renuncia expresa a cualquier otro fuero que pudiera corresponderles.
            </p>
          </section>

          <p className="text-slate-500 text-sm mt-12">
            Última actualización: {new Date().toLocaleDateString('es-ES', { year: 'numeric', month: 'long', day: 'numeric' })}
          </p>
        </div>
      </div>
    </div>
  );
};

export default AvisoLegal;
